var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.44713 3.81956C1 4.38228 1 5.185 1 6.79042V7.64671C1 9.25213 1 10.0548 1.44713 10.6176C1.59153 10.7993 1.76632 10.9591 1.96508 11.0912C2.58049 11.5 3.45838 11.5 5.21415 11.5C6.96992 11.5 7.84781 11.5 8.46323 11.0912C8.66198 10.9591 8.83677 10.7993 8.98117 10.6176C9.4283 10.0548 9.4283 9.25213 9.4283 7.64671V6.79042C9.4283 5.185 9.4283 4.38228 8.98117 3.81956C8.83677 3.63783 8.66198 3.47801 8.46323 3.34597C7.84781 2.93713 6.96992 2.93713 5.21415 2.93713C3.45838 2.93713 2.58049 2.93713 1.96508 3.34597C1.76632 3.47801 1.59153 3.63783 1.44713 3.81956Z",
    fill: "#828D99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.34117 5.18488C3.14722 5.18488 2.98999 5.32865 2.98999 5.50599C2.98999 5.68333 3.14722 5.8271 3.34117 5.8271H7.08708C7.28103 5.8271 7.43826 5.68333 7.43826 5.50599C7.43826 5.32865 7.28103 5.18488 7.08708 5.18488H3.34117ZM3.34117 6.89746C3.14722 6.89746 2.98999 7.04122 2.98999 7.21856C2.98999 7.39591 3.14722 7.53967 3.34117 7.53967H7.08708C7.28103 7.53967 7.43826 7.39591 7.43826 7.21856C7.43826 7.04122 7.28103 6.89746 7.08708 6.89746H3.34117ZM3.34117 8.61003C3.14722 8.61003 2.98999 8.7538 2.98999 8.93114C2.98999 9.10848 3.14722 9.25225 3.34117 9.25225H7.08708C7.28103 9.25225 7.43826 9.10848 7.43826 8.93114C7.43826 8.7538 7.28103 8.61003 7.08708 8.61003H3.34117Z",
    fill: "url(#paint0_linear_872_3768)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.01883 2.38244C2.92406 2.5017 2.84938 2.63175 2.79053 2.77793C3.38497 2.57784 4.22342 2.57784 5.60707 2.57784C7.36284 2.57784 8.24072 2.57784 8.85614 2.98669C9.0549 3.11872 9.22969 3.27854 9.37409 3.46028C9.82122 4.023 9.82122 4.82571 9.82122 6.43114V7.28743C9.82122 8.55259 9.82122 9.31924 9.60239 9.86279C9.76227 9.80897 9.90449 9.74069 10.0349 9.65403C10.2337 9.522 10.4085 9.36217 10.5529 9.18044C11 8.61772 11 7.815 11 6.20958V5.35329C11 3.74787 11 2.94516 10.5529 2.38244C10.4085 2.2007 10.2337 2.04088 10.0349 1.90884C9.41951 1.5 8.54162 1.5 6.78585 1.5C5.03008 1.5 4.15219 1.5 3.53677 1.90884C3.33802 2.04088 3.16323 2.2007 3.01883 2.38244Z",
    fill: "#A6ACB3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_872_3768",
    x1: 6.08421,
    y1: 13.6304,
    x2: 19.8858,
    y2: 0.101463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.679c020e715819f59790a929d6673dbf.svg";
export { ForwardRef as ReactComponent };